import { useEffect, useState, useContext, useRef} from 'react'
import {  Link, useLocation, useParams } from "react-router-dom";
import {Helmet} from "react-helmet";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";

import { MdOutlineSettingsInputComponent, MdOutlineArrowLeft } from "react-icons/md";

import Main from "./Main";
import { AppContext } from "../../Context";
import { Config } from "../../inc/Config";
import { Loader, FetchAsync, GET, permissions } from "../../inc/Fetch";
import { Img } from "../../components/Elements";
import AudioList from "./components/AudioList";
import Permission from "../Permission";
import Filter from "../../components/Filter";

import './css/audio.css'

export default function Audio() {

    const { t } = useTranslation();
    const location = useLocation();
    const params = useParams();

    const { userData, siteData } = useContext(AppContext); 
    const [site, setsite] = siteData;
    const [userinfo, setuserinfo] = userData;

    const [filterOpen, setfilterOpen] = useState(false);
    const [filter, setfilter] = useState({});
    const [subjects, setsubjects] = useState([]);
    const [data, setdata] = useState({});
    const [isLoading, setisLoading] = useState(true);

    let catID = site?.cats?.filter(r => r?.name == params?.id);
    catID = catID?.length ? catID[0]?._id : false;

    if (!params?.page) {
        params.page = 1; 
    }


    async function loadData(page) {
        let res = await FetchAsync(`audio/view`, { _id: catID, filter:filter, page:page });
        setdata(res);
        setisLoading(false);
    }

    // const { data, error, isLoading, refetch } = useQuery("audio", loadData); 

    function searchForm(e) {
        e.preventDefault();
        loadData();
        setfilterOpen(false);
    }

    useEffect(() => {
        setisLoading(true);
        loadData(params?.page);
    }, [params?.page]);

    useEffect(() => {
        let catID = site?.cats?.filter(r => r?.name == params?.id);

        
        if (catID?.length) {
            let r = catID[0];
            setsubjects(r?.subs);
        }
        
    }, [catID])
    

    if (isLoading) {
        return <Loader />
    }
    
    if (!userinfo?._id) {
        return <Permission />
    } else {
        
        let perms = permissions(userinfo, false, catID, "music");
        if (!perms) {
            return <Permission />
        }
        
    }

    let pages = Math.ceil(data?.count / 40);

	return (
		<>
        <Filter  Open={filterOpen} setOpen={setfilterOpen}>
            <form onSubmit={searchForm} className='filterFormBox'>
                <div style={{flex:1}}>
                    <label>
                        <span>{t("keywords")}</span>
                        <input type='search' 
                            onChange={(d) => setfilter(p => ({
                                ...p,
                                text:d?.target?.value,
                            }))}
                            value={filter?.text}
                            placeholder={`${t("search")}..`} 
                        />
                    </label>

                    <label>
                        <span>{t("subject")}</span>
                        <select
                            onChange={(d) => setfilter(p => ({
                                ...p,
                                subject:d?.target?.value,
                            }))}
                        >
                            <option value="">--</option>
                            {subjects?.map((v, k) => {

                                return (
                                    <option key={k} value={v?._id}>{v?.name}</option>
                                );

                            })}
                            
                        </select>
                    </label>

                    <label>
                        <span>{t("classes")}</span>
                        <select
                            onChange={(d) => setfilter(p => ({
                                ...p,
                                classes:d?.target?.value,
                            }))}
                        >
                            <option value="">--</option>
                            {Object.entries(global.Classes)?.map((v, k) => {

                                return (
                                    <option key={k} value={v[0]}>{t("class")} {v[1]}</option>
                                );

                            })}
                            
                        </select>
                    </label>

           
                </div>
                <button className='btn'>{t("start_searching")}</button>
            </form>
        </Filter>
        <Main>

            <div style={{ paddingTop:155 }}  className="mainWidth">
                <nav className='breadcrumbs'>
                    <Link to={`/site/${params?.id}`}>{t("home")}</Link>
                    <MdOutlineArrowLeft />
                    <Link>{t("audio_title")}</Link>
                
                </nav>
            </div>

            <div className='section4'>

                <div className="mainWidth">
                    
                    <div style={{marginTop:20}} className='mainSectionBox inside'>
                        <div>
                            <h1>{t("audio_title")}</h1>
                            <hr />
                        </div>

                        <div style={{display:"flex", gap:5}}>
                            <Link onClick={() => setfilterOpen(r => !r)} title={t("filter")} className='btn openFilter'><MdOutlineSettingsInputComponent /></Link>
                        </div>

                    </div>

                    
                    <div className='audioListBox'>
                        {data?.audio?.map((v, k) => {
                            return(
                                <AudioList v={v} key={k}/>
                            )
                        })}

                    </div>

                    {pages > 0 &&
                    <nav className='pagingBox'>
                        {/* data?.count */}
                        {Array.from(Array(pages), (e, i) => {
                            let lin = `/site/${params?.id}/audio/${i + 1}`;
                            if (!i) {
                                lin = `/site/${params?.id}/audio`;
                            }

                            return <Link to={lin} className={`${params?.page == i + 1 ? "ck" : "null"}`} key={i}>{i + 1}</Link>
                        })}
                    </nav>}
                </div>
            </div>

         
        </Main>

		</>
	)
}
